import React from "react";
import "../home.css";
import { Link } from "react-router-dom";
const cards = [
  {
    bg: "https://plus.unsplash.com/premium_photo-1682716270464-9a91cbbcf3b7?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8Q29tcGFuaWVzfGVufDB8fDB8fHww",
    // icon: (...),
    // title: "Real Companies",
    desc: "Work with actual startups and enterprises",
  },
  {
    bg: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0",
    // icon: (...),
    // title: "Mentorship",
    desc: "Guided by industry professionals",
  },
  {
    bg: "https://images.unsplash.com/photo-1648337564744-f919c7c2fc02?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8Y2VydGlmaWNhdGV8ZW58MHx8MHx8fDA%3D",
    // icon: (...),
    // title: "Certification",
    desc: "Get verified completion certificates",
  },
  {
    bg: "https://images.unsplash.com/photo-1579616043939-95d87a6e8512?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8dHJhY2tpbmd8ZW58MHx8MHx8fDA%3D",
    // icon: (...),
    // title: "Fast Track",
    desc: "Direct path to job opportunities",
  },
];

function InternshipExperience() {
  return (
    <div className="bg-gray-900 min-h-screen flex flex-col md:flex-row md:pt-28">
      <div className="flex-1 px-6 md:px-24 py-12 lg:pl-16">
        <div className="intern-title font-black leading-tight">
          Grow Through,{" "}
          <span className="intern-highlight">Real Experience</span>
        </div>
        <div className="intern-desc">
          Step into a world where one click opens endless possibilities. At Acadme, learning isn’t limited to screens—it comes alive through real work, real projects, and real industry exposure. Here, you collaborate with experts, solve authentic challenges, and build a portfolio that speaks louder than any certificate. Every experience pushes your growth forward and prepares you for the career you dream of.
        </div>
        <div className="intern-desc-sub">
        Apply now and turn that one click into endless opportunities, endless skills, and endless success.
        </div>
        <Link to="/register">
        <button className="intern-btn">Apply for Internships</button>
        </Link>
      </div>
      <div className="flex-1 pr-6 pt-14 md:pt-0 md:pl-0 md:pr-16">
        <div className="intern-cards">
          {cards.map((c) => (
            <div key={c.title} className="intern-card">
              <div className="intern-card-inner">
                {/* Front Side */}
                {/* <div className="intern-card-front">
          <div className="intern-card-icon-bg">{c.icon}</div>
          <div className="intern-card-title">{c.title}</div>
        </div> */}
                <div
                  className="intern-card-front"
                  style={{
                    backgroundImage: `url(${c.bg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="intern-card-overlay"></div>
                  <div className="intern-card-icon-bg">{c.icon}</div>
                  <div className="intern-card-title">{c.title}</div>
                </div>

                <div className="intern-card-back">
                  <div className="intern-card-desc">{c.desc}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default InternshipExperience;
